const searchUtil = {
  methods: {
    closeSearch () {
      this.$store.commit('setFocusSearch', false)
      this.$store.commit('setSearchQuery', '')

      Modal.prototype._resetScrollbar() // eslint-disable-line no-undef
    },

    closeSearchInput () {
      this.$store.commit('setFocusSearch', false)
      this.$store.commit('setShowSearchResults', false)
      this.$store.commit('setSearchQuery', '')

      Modal.prototype._resetScrollbar() // eslint-disable-line no-undef
    }
  }
}

const sidebarUtil = {
  methods: {
    closeSidebar () {
      this.$store.commit('setShowSidebar', false)
      this.$store.commit('setShowViewResults', false)

      if ($('body')) {
        $('body').removeClass('disable-scroll')
      }
    }
  }
}

const scrollUtil = {
  methods: {
    scrollToElement (selector = 'body', offset, duration = 300) {
      this.$scrollTo(selector, duration, { offset })
    }
  }
}

export {
  searchUtil,
  sidebarUtil,
  scrollUtil
}
